import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchResults = ({ totalProducts, filteredCount, searchQuery }) => {
  const hasActiveSearch = searchQuery?.trim()?.length > 0;

  return (
    <div className="flex items-center justify-between bg-muted rounded-lg px-4 py-3 border border-border">
      <div className="flex items-center space-x-2">
        <Icon name="Search" size={16} className="text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">
          {hasActiveSearch ? (
            <>
              Trovati <span className="font-semibold text-primary">{filteredCount}</span> di {totalProducts} prodotti
            </>
          ) : (
            <>
              Visualizzando <span className="font-semibold text-primary">{totalProducts}</span> prodotti
            </>
          )}
        </span>
      </div>

      {hasActiveSearch && (
        <div className="flex items-center space-x-1 text-xs text-muted-foreground">
          <Icon name="Filter" size={14} />
          <span>Filtro attivo</span>
        </div>
      )}
    </div>
  );
};

export default SearchResults;